<template>
  <div class="employee_requests">
    <div class="content">
      <p class="page-title">{{ $route.name }}</p>
      <div class="card">
        <p class="title">Your Employee Requests</p>
        <div class="table-holder">
          <table>
            <thead>
              <tr>
                <th>Time Requested</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Add Employee</th>
                <th>Remove</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="employee_requests.length">
                <template v-for="(item, i) in employee_requests">
                  <tr :key="i" :class="{ grey: i % 2 }">
                    <td data-label="Time Requested">
                      <div class="img-text">{{ parseInt(item.created_at) | format_date_time }}</div>
                    </td>
                    <td data-label="First Name">{{ item.first_name }}</td>
                    <td data-label="Last Name">{{ item.last_name }}</td>
                    <td data-label="Edit">
                      <img
                        @click="handleEdit(item)"
                        class="action clickable"
                        src="@/assets/img/add.svg"
                      />
                    </td>
                    <td data-label="Edit">
                      <img
                        @click="handleDelete(item)"
                        class="action clickable"
                        src="@/assets/img/delete.svg"
                      />
                    </td>
                  </tr>
                </template>
              </template>
              <template v-else>
                <tr>
                  <td>You have no employee requests</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <transition name="fade">
      <popup v-if="current_employee">
        <p class="title">Add {{current_employee.first_name}}'s Employee Number</p>
        <div class="inputs">
          <div class="input">
            <label>Employee Number</label>
            <input v-model="employee_pin" />
          </div>
          <transition name="fade">
            <p v-if="error" class="full error error-msg">{{error}}</p>
          </transition>

          <transition name="fade">
            <button
              v-if="loading == 'hide'"
              @click="validateEmployeePin()"
              class="btn full"
              style="cursor: pointer; text-decoration: underline"
            >Save User</button>
          </transition>
          <transition name="fade">
            <div class="full">
              <img class="loading" v-if="loading == 'show'" src="@/assets/img/loader.gif" />
            </div>
          </transition>
        </div>
      </popup>
    </transition>
  </div>
</template>

<script>
import Register from "@/components/Register";
import firebase from "firebase";
import Popup from "@/components/Popup";
import Swal from "sweetalert2";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const auth = fb.default.auth;

export default {
  name: "EmployeeRequests",
  components: {
    register: Register,
    popup: Popup
  },
  data() {
    return {
      employee_requests: [],
      user: this.$store.state.user_doc,
      showPopup: true,
      current_employee: null,
      employee_pin: null,
      error: false,
      loading: "hide"
    };
  },
  async created() {
    db.collection("user")
      .doc(this.user_doc.id)
      .collection("employee_request")
      .orderBy("created_at")
      .onSnapshot(snapshot => {
        this.employee_requests = snapshot.docs.map(doc => {
          let data = doc.data();
          data.id = doc.id;
          return data;
        });
      });
  },
  methods: {
    handleEdit(item) {
      this.showPopup = true;
      this.current_employee = item;
    },
    handleDelete(item) {
      Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to undo this",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "DELETE",
        cancelButtonText: "CANCEL"
      }).then(result => {
        if (result.value) {
          db.collection("user")
            .doc(this.user_doc.id)
            .collection("employee")
            .doc(item.id)
            .delete();
          return db
            .collection("user")
            .doc(this.user_doc.id)
            .collection("employee_request")
            .doc(item.id)
            .delete()
            .then(() => {
              Swal.fire("Deleted!", `The request has been deleted.`, "success");
            });
        }
      });
    },
    async validateEmployeePin() {
      this.error = null;
      if (this.employee_pin) {
        this.loading = "show";
        let result = await db
          .collection("user")
          .doc(this.user_doc.id)
          .collection("employee")
          .where("employee_number", "in", [this.employee_pin, parseInt(this.employee_pin)])
          .get()
          .then(snapshot => {
            if (snapshot.docs.length) {
              return false;
            } else {
              return true;
            }
          });
        if (result) {
          this.current_employee.employee_number = this.employee_pin;
          await db
            .collection("user")
            .doc(this.user_doc.id)
            .collection("employee")
            .doc(this.current_employee.id)
            .set(this.current_employee)
            .then(() => {
              return true;
            });
          await db
            .collection("user")
            .doc(this.user_doc.id)
            .collection("employee_request")
            .doc(this.current_employee.id)
            .delete()
            .then(() => {
              this.loading = "hide";
              this.current_employee = null;
              this.employee_pin = null;
              return true;
            });
        } else {
          this.error = "This pin has been taken.";
          this.loading = "hide";
        }
      } else {
        this.loading = "hide";
        this.error = "Please enter a pin.";
      }
    }
  }
};
</script>

<style lang="scss">
.stats {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .card {
    width: 49%;
    position: relative;
    padding-top: 70px;
    transition: box-shadow 0.3s;
    cursor: pointer;
    &:hover {
      box-shadow: 0 0 15px rgba(128, 128, 128, 0.8);
    }
    img {
      position: absolute;
      z-index: 0;
      opacity: 0.1;
      height: 80%;
      right: 10%;
      top: 50%;
      transform: translateY(-50%);
    }
    .stat {
      font-size: 80px;
      color: #49c6d4;
      font-weight: 500;
      margin: 0;
      span {
        display: block;
        font-size: 16px;
        color: #132628;
        font-weight: 500;
        margin-top: -10px;
      }
    }
  }
}

.error-msg {
  text-align: left;
  margin: 0;
}

.loading {
  height: 75px;
}
</style>
